import AbstractFilterDefinition from './AbstractFilterDefinition.js'

export default class AutocompleteFilterDefinition extends AbstractFilterDefinition
{
    constructor(name, label, objectType) {
        super(name, label);
        this.objectType = objectType;
    }

    get component() {
        return 'autocomplete-filter';
    }

    dataAdapter(data) {
        let ids =  data.choices.map((item) => +item.id);

        switch (data.mode) {
            case 'contain':
                return { 'match': ids };
            case 'dontcontain':
                return { 'not_match': ids };
            case 'known':
                return { 'not_match': [] };
            case 'unknown':
                return { 'match': [] };
        }

        return null;
    }

    get configuration() {
        let configuration =  {
            "choices": {
                "name": "choices",
                "options": {
                    "max": 20,
                    "searchOnFocus": true,
                    "type": this.objectType
                }
            },
            "mode": {
                "type": "radio",
                "name": "mode",
                "options": {
                    "contain": {
                        "value": "contain",
                        "label": i18n.__("Contient")
                    },
                    "dontcontain": {
                        "value": "dontcontain",
                        "label": i18n.__("Ne contient pas")
                    },
                    "known": {
                        "value": "known",
                        "label": i18n.__("Est connu")
                    },
                    "unknown": {
                        "value": "unknown",
                        "label": i18n.__("Est inconnu")
                    },
                }
            }
        };
        return configuration;
    }
}